import { css } from "styled-components";

// FreeText 본문 공통 스타일 (작성 화면 .ProseMirror / 열람 화면 본문에 같이 적용)
export const freeTextContentCss = css`
  font-size: 16px;
  line-height: 1.7;
  color: #1f1f1f;
  word-break: keep-all;
  overflow-wrap: anywhere;

  p {
    margin: 0 0 0.5em;
    min-height: 1.7em;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 1em 0 0.5em;
    line-height: 1.35;
    font-weight: 700;
  }
  h1 { font-size: 2em; }
  h2 { font-size: 1.6em; }
  h3 { font-size: 1.3em; }
  h4 { font-size: 1.1em; }

  ul,
  ol {
    margin: 0 0 0.5em;
    padding-left: 1.6em;
  }
  li > p {
    margin: 0;
  }

  blockquote {
    margin: 0.5em 0;
    padding: 0.25em 1em;
    border-left: 3px solid #d9d9d9;
    color: #595959;
  }

  hr {
    margin: 1em 0;
    border: none;
    border-top: 1px solid #d9d9d9;
  }

  a {
    color: #1677ff;
    text-decoration: underline;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0.5em 0;
  }

  table {
    width: 100%;
    margin: 0.5em 0;
    border-collapse: collapse;
    table-layout: fixed;
  }
  th,
  td {
    min-width: 2em;
    padding: 6px 8px;
    border: 1px solid #d9d9d9;
    vertical-align: top;
  }
  th {
    background: #fafafa;
    font-weight: 600;
    text-align: left;
  }
  th > p,
  td > p {
    margin: 0;
  }
`;
